/**
 * homepage-premium.js
 * Shared across all homepage-* sections:
 *  - scroll-reveal (IntersectionObserver, respects prefers-reduced-motion)
 *  - tab switcher (Featured Product Tabs)
 *  - lightweight carousel controller (prev/next arrows, optional autoplay)
 */
(function () {
  'use strict';

  if (window.__hpPremiumInitialized) return;
  window.__hpPremiumInitialized = true;

  /* ---------------------------------------------------------------------
   * Scroll reveal
   * ------------------------------------------------------------------- */
  function initScrollReveal() {
    var els = document.querySelectorAll('[data-hp-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      return; /* elements are visible by default; nothing to do */
    }

    els.forEach(function (el) { el.classList.add('hp-reveal-armed'); });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = entry.target.dataset.hpRevealDelay || 0;
            window.setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, parseInt(delay, 10));
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------------
   * Tab switcher (Featured Product Tabs)
   * ------------------------------------------------------------------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-hp-tab]');
    var panels = root.querySelectorAll('[data-hp-tab-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.hpTab;

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        tab.classList.add('is-active');
        var panel = root.querySelector('[data-hp-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  document.querySelectorAll('[data-hp-tabs]').forEach(initTabs);

  /* ---------------------------------------------------------------------
   * Lightweight carousel (product grid slider arrows, brand logos)
   * ------------------------------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-hp-carousel-track]');
    var prevBtn = root.querySelector('[data-hp-carousel-prev]');
    var nextBtn = root.querySelector('[data-hp-carousel-next]');
    var dotsWrap = root.querySelector('[data-hp-carousel-dots]');
    if (!track) return;

    function itemWidth() {
      return track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width : 300;
    }

    function scrollByAmount(direction) {
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 20);
      track.scrollBy({ left: direction * (itemWidth() + gap), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByAmount(1); });

    if (dotsWrap && track.children.length) {
      var gap = parseFloat(window.getComputedStyle(track).columnGap || 20);
      var perView = Math.max(1, Math.round(track.clientWidth / (itemWidth() + gap)));
      var pageCount = Math.max(1, Math.ceil(track.children.length / perView));
      var dots = [];

      for (var i = 0; i < pageCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hp-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (pageIndex) {
          dot.addEventListener('click', function () {
            track.scrollTo({ left: pageIndex * perView * (itemWidth() + gap), behavior: 'smooth' });
          });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }

      var scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var activePage = Math.round(track.scrollLeft / (perView * (itemWidth() + gap)));
          dots.forEach(function (d, idx) {
            d.classList.toggle('is-active', idx === activePage);
          });
        }, 100);
      });
    }

    if (root.dataset.hpCarouselAutoplay === 'true') {
      var speed = parseInt(root.dataset.hpCarouselSpeed, 10) || 3000;
      var timer = window.setInterval(function () {
        var atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }, speed);

      if (root.dataset.hpCarouselPauseHover === 'true') {
        root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
      }
    }
  }

  document.querySelectorAll('[data-hp-carousel]').forEach(initCarousel);

  /* ---------------------------------------------------------------------
   * Newsletter form (AJAX-free graceful success message, no page reload
   * for stores using a custom endpoint; falls back to native submission
   * for the standard Shopify /contact#newsletter form).
   * ------------------------------------------------------------------- */
  document.querySelectorAll('[data-hp-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var successMsg = form.parentElement.querySelector('[data-hp-newsletter-success]');
      if (successMsg) {
        window.setTimeout(function () {
          successMsg.hidden = false;
        }, 400);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', initScrollReveal);
  if (document.readyState !== 'loading') initScrollReveal();

})();
